module.exports = __webpack_public_path__ + "src/img/marleyspoon/marleyspoon-image-1.cf27d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/marleyspoon/marleyspoon-image-1.png
// module id = 252
// module chunks = 0